<template>
     <section id="Portfolio">
            <div class="container text-center" data-aos="fade-up" data-aos-duration="3000">

               <div class="p-5 text-center bg-body-tertiary rounded-3">
                <img src="images/porfolio_icon.png" width="80" style="margin-top: 20px;">
                <h1 class="text-body-emphasis">Portfolio</h1>
                <p class="lead">
                  Explore our portfolio to see how we've helped businesses like yours achieve their goals.<br>Ready to take your business to the next level?</p>
              </div>
              <br> 
                <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
                  <div class="col"  data-aos="fade-up" data-aos-delay="300">
                    <div class="card shadow-sm">
                     <img src="images/porfolio.png" width="100%">
                      <div class="card-body">
                        <p class="card-text"> Our multi-skilled experienced team facilitates businesses worldwide on their way to digital transformation and helps companies take full advantage of IT innovations. </p>
                      </div>
                    </div>
                  </div>
                  <div class="col"  data-aos="fade-up" data-aos-delay="500">
                    <div class="card shadow-sm">
                      <img src="images/trade_docs.jpg" width="100%">
                      <div class="card-body">
                        <p class="card-text">The exporters need to apply for Certificate of Origin (C/O) at the Ministry of Commerce to get preferential treatment. The procedures of the C/O Issuance could be found in Prakas No.3198.</p>
                      </div>
                    </div>
                  </div>
                  <div class="col" data-aos="fade-up" data-aos-delay="700">
                    <div class="card shadow-sm">
                     <img src="images/obr.jpg" width="100%">
                      <div class="card-body">
                        <p class="card-text">Now register your business within days using the Royal Government of Cambodia’s Online Business Registration system. Hassle-free, convenient, time- and cost-saving!</p>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
    </section>
</template>